import React, { useEffect, useState } from 'react'
import { useDataTable } from '../../../shared/hooks/DataTable';
import { InvoiceService } from '../../hoa-don/InvoiceService';
import { InvoiceDiscountList } from '../../../service/invoice/InvoiceDiscountList';
import { useToolbar } from '../../../shared/hooks/Toolbar';
import DialogDiscountInvoiceAttachment from './components/DialogDiscountInvoiceAttachment';

const List = () => {
  const header = 'Hoá đơn điều chỉnh';
  const dataKey = 'id';
  const [selectInvoiceDiscounted, setSelectInvoiceDiscounted] = useState([])
  const [displayDiscountInvoiceAttachment, setDisplayDiscountInvoiceAttachment] = useState(false)

  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      {
        field: 'status',
        header: 'Trạng thái',
        width: 100,
        matchMode: 'contains',
        dataType: 'custom',
        filterType: 'dropdown',
        filterOptions: [{ label: 'Chờ ký', value: 0 }, { label: 'Đã ký', value: 1 }],
        customCell(rowData: any): any {
          if (!rowData.status) {
            return <span className='invoice-list-discount-status invoice-list-discount-status-0'>Chờ ký</span>;
          }
          return <span className='invoice-list-discount-status invoice-list-discount-status-1'>Đã ký</span>;
        }
      },
      { field: 'invoiceListNumber', header: 'Số bảng kê', width: 110, matchMode: 'contains' },
      { field: 'invoiceListDate', header: 'Ngày bảng kê', width: 120, dataType: 'date', matchMode: 'equals', filterType: 'date', },
      { field: 'buyerLegalName', header: 'Tên khách hàng', width: 180, matchMode: 'contains', },
      { field: 'buyerTaxCode', header: 'Mã số thuế', width: 150, matchMode: 'contains' },
      { field: 'buyerAddress', header: 'Địa chỉ', minWidth: 200, matchMode: 'contains' },
      {
        field: 'totalAmountWithoutVAT',
        header: 'Tổng tiền trước thuế',
        width: 150,
        matchMode: 'contains',
        dataType: 'custom',
        customCell(rowData: any): any {
          return <span>{new Intl.NumberFormat('vi-VN').format(rowData.totalAmountWithoutVAT)}</span>;
        },
        style: { justifyContent: 'end' }

      },
      {
        field: 'vatAmount', header: 'Tổng tiền thuế', width: 150, matchMode: 'contains',
        dataType: 'custom',
        customCell(rowData: any): any {
          return <span>{new Intl.NumberFormat('vi-VN').format(rowData.vatAmount)}</span>;
        },
        style: { justifyContent: 'end' }
      },
      {
        field: 'totalFee', header: 'Tổng tiền phí', width: 150, matchMode: 'contains',
        dataType: 'custom',
        customCell(rowData: any): any {
          return <span>{new Intl.NumberFormat('vi-VN').format(rowData.totalFee)}</span>;
        },
        style: { justifyContent: 'end' }
      },
      {
        field: 'totalAmount', header: 'Tổng tiền thanh toán', width: 150, matchMode: 'contains',
        dataType: 'custom',
        customCell(rowData: any): any {
          return <span>{new Intl.NumberFormat('vi-VN').format(rowData.totalAmount)}</span>;
        },
        style: { justifyContent: 'end' }
      },
      { field: 'note', header: 'Ghi chú', width: 110, matchMode: 'contains' },
      { field: '', header: 'Người tạo', width: 110, matchMode: 'contains' },
      { field: '', header: 'Ngày tạo', width: 110, dataType: 'date', matchMode: 'equals', filterType: 'date', },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.IsOtherInvoice = false;
      return InvoiceDiscountList.getList(params);
    },
    selectionMode: 'single'
  });

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey,
    otherActions: [
      {
        label: 'Sửa',
        icon: 'pi pi-fw pi-pencil',
        className: 'iam-toolbar iam-toolbar-info',
        command: () => {
          setDisplayDiscountInvoiceAttachment(true)
        },
        disabled: Array.isArray(selectedItems)
      },
      {
        label: 'Xem in',
        icon: 'pi pi-fw pi-print',
        className: 'iam-toolbar iam-toolbar-success',
        command: () => {
          if (Array.isArray(selectedItems)) {
            return
          }
          if (typeof selectedItems === "object" && selectedItems !== null && 'id' in selectedItems) {
            InvoiceDiscountList.getPdf((selectedItems as { id: string }).id)
          }
        },
        disabled: Array.isArray(selectedItems)
      }
    ]
  });

  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {renderToolbar()}
      {renderDataTable()}
      <DialogDiscountInvoiceAttachment
        display={displayDiscountInvoiceAttachment}
        setInvoices={setSelectInvoiceDiscounted}
        setDisplay={setDisplayDiscountInvoiceAttachment}
        selectedItems={selectedItems}
        reloadLazyData={reloadLazyData}
      />

    </>
  )
}

export default List